import PropTypes from "prop-types";
import React from "react";

import AnemoneIllustrationDesktopDark from "images/illustrations/Anemone-Illustration-dark.inline.svg";
import AnemoneIllustrationDesktopLight from "images/illustrations/Anemone-Illustration-light.inline.svg";
import AnemoneIllustrationMobile from "images/illustrations/Anemone-Illustration-mobile.inline.svg";

import ContactForm from "../../components/forms/contact";
import Image from "../../components/image";
import { useTheme } from "../../context/ThemeContext";

const Testimonials = ({
  testimonials,
  type,
  form_type,
  heading,
  subHeading,
  ctaLabel,
  bgSrc,
  bgCol,
  bgType,
  sectionBgClass,
  illustrationSrc,
  layout,
  testimonialContainerBg = "bg-green-light rounded-xxs flex-wrap border-0.5 border-gray-testimonial/30",
  desktopImageClass = "w-full h-full object-cover",
  mobileImageClass = "w-full h-full object-cover",
  hiddenFields = [],
  formTooltipIconStyles,
  formTooltipStyles,
  calendlyLayout,
  calendlyDesc,
  calendlyActive,
  formStatusExtraContainerClass,
  formStatusIconColorClass,
  formStatusHeadingTextProcessing,
  formStatusHeadingTextSuccess,
  formStatusBriefTextProcessing,
  formStatusBriefTextSuccess,
  formAdditionalFieldContainerClass = "",
  formContactLabelsClass = "",
  formAdditionalProps = {},
  formStatusCompTextColorClass = "text-white"
}) => {
  const { colorMode } = useTheme();
  const isNoTestimonials = testimonials ? testimonials.length === 0 : true;
  const [formProcessStatus, setProcessingStatus] = React.useState("");

  // console.debug("formProcessStatus", formProcessStatus);
  return (
    <>
      <section
        className={`summary-section program-testimonials relative flex flex-col items-center ${
          bgCol ?? sectionBgClass
        } ${bgType === "unity" ? "sm:py-32 bg-cover bg-center" : "sm:pb-32"}`}
        style={{
          backgroundImage: `url(${
            bgType === "unity"
              ? colorMode === "light"
                ? bgSrc.light.desktop
                : bgSrc.dark.desktop
              : ""
          })`
        }}
      >
        {bgType === "split" && (
          <>
            {type === "program" && (
              <>
                <div className="w-full z-0 !hidden h-auto sm:!block">
                  <Image
                    imageAlt="Testimonial bg"
                    image={""}
                    imageClass={desktopImageClass}
                    sourceUrl={
                      colorMode === "light"
                        ? bgSrc.light.desktop
                        : bgSrc.dark.desktop
                    }
                  />
                </div>
                <div className="!absolute h-full w-full z-0 block sm:!hidden">
                  <Image
                    imageAlt="Testimonial bg"
                    image={""}
                    imageClass={mobileImageClass}
                    sourceUrl={
                      colorMode === "light"
                        ? bgSrc.light.mobile
                        : bgSrc.dark.mobile
                    }
                  />
                </div>
              </>
            )}

            {type === "sign-up" && (
              <div className="!absolute md:!relative w-full z-0 h-1/2 md:h-full">
                <Image
                  imageAlt="Testimonial bg"
                  image={""}
                  imageClass={desktopImageClass}
                  sourceUrl={
                    colorMode === "light"
                      ? bgSrc.light.desktop
                      : bgSrc.dark.desktop
                  }
                />
              </div>
            )}
            {type === "vi-landing" && (
              <>
                <Image
                  imageAlt="Testimonial background"
                  image={""}
                  imageClass="w-full z-0 !hidden h-auto sm:!block"
                  sourceUrl={bgSrc.light.desktop}
                />{" "}
                <Image
                  imageAlt="Testimonial background"
                  image={""}
                  imageClass="!absolute h-full w-full z-0 block sm:!hidden bg-black object-cover"
                  sourceUrl={bgSrc.light.mobile}
                />
              </>
            )}
          </>
        )}

        <div
          className={`container relative w-11/12 sm:w-10/12 z-10 sm:p-0 overflow-hidden
            ${isNoTestimonials ? "my-8" : "pt-20 pb-28"} ${
              type === "sign-up" ? "sm:!w-4/5" : ""
            }
        ${bgType === "unity" ? "sm:mt-0" : "sm:-mt-28"}`}
        >
          <div
            className={`container testimonial-container flex ${
              isNoTestimonials ? testimonialContainerBg : "flex-nowrap gap-x-10"
            } sm:flex-nowrap`}
          >
            {isNoTestimonials && (
              <>
                {illustrationSrc.dark}
                {illustrationSrc.light}
              </>
            )}
            <AnemoneIllustrationMobile
              className={`z-10 w-full !absolute top-0 sm:!hidden ${
                isNoTestimonials && type === "program" ? "!block" : "!hidden"
              }`}
            />

            <div
              className={`testimonial-wrapper rounded-md ${
                isNoTestimonials
                  ? "w-11/12 mx-auto sm:m-0 flex items-center justify-center"
                  : "w-full py-10 px-7 md:p-10 bg-white "
              } ${isNoTestimonials && formProcessStatus ? "mt-0" : "mt-8"} sm:w-full`}
            >
              {isNoTestimonials && !formProcessStatus && (
                <div className="testimonial-desc align-center sm:h-96 sm:w-2/3 md:flex md:flex-col md:justify-center relative">
                  <h1
                    className="heading text-left uppercase py-2 !text-white leading-[31px] md:leading-[43px]"
                    dangerouslySetInnerHTML={{
                      __html: heading
                    }}
                  />
                  <div
                    className="subheading sm:py-6 text-mob text-left text-white "
                    dangerouslySetInnerHTML={{
                      __html: subHeading
                    }}
                  />
                </div>
              )}

              {!isNoTestimonials && (
                <div className="testimonial-list ">
                  {type === "program" && (
                    <div
                      className="font-tabheading tracking-wide sm:py-4 text-[16px] w-1/3 text-left uppercase text-generic-text  border-b border-gray-lighter"
                      dangerouslySetInnerHTML={{
                        __html: `${testimonials?.length} review${testimonials?.length > 1 ? "s" : ""}`
                      }}
                    />
                  )}
                  <div className="testimonial-list overflow-y-auto gvi-scrollbar-thin h-52 sm:h-80">
                    {testimonials?.map((testimonial, idx) => (
                      <div
                        className="testimonial text-generic-text  pr-10 pt-3"
                        key={`_testimonial_${idx}`}
                      >
                        <h3 className="testimonial-title font-normal">
                          {testimonial?.title}
                        </h3>
                        <div className="testimonial-date text-sm py-2">
                          {testimonial?.date}
                        </div>
                        <div className="testimonial-content tab-content_html">
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                testimonial?.testimonialReviewsFields
                                  ?.rvwOverallReview ?? testimonial?.content
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {(form_type !== "no-form" || type !== "vi-landing") && (
              <ContactForm
                formType={type}
                customFormType={form_type}
                formHeading={`${!isNoTestimonials ? "Get more info" : ""}`}
                formHeadingAdditionalClass={"xs:text-white uppercase"}
                ctaLabel={ctaLabel}
                scrollToTop={false}
                formStyles={`contact-form white-outline shrink-0 ${
                  isNoTestimonials
                    ? "min-h-full h-auto justify-center w-11/12 mx-auto sm:mx-0 sm:w-5/12 pt-6 pb-8 sm:p-14 sm:pb-7 relative"
                    : "hidden sm:block sm:w-1/3 bg-green-light gvi-border-light border-0.5 border-gray-testimonial rounded-br-[3px] rounded-bl-[3px] px-6 pt-5 pb-10"
                }`}
                txtColor={formStatusCompTextColorClass}
                setParentStatus={setProcessingStatus}
                hiddenFields={hiddenFields}
                formTooltipIconStyles={formTooltipIconStyles}
                formTooltipStyles={formTooltipStyles}
                calendlyLayout={calendlyLayout}
                calendlyDesc={calendlyDesc}
                calendlyActive={calendlyActive}
                formStatusExtraContainerClass={formStatusExtraContainerClass}
                expTextProcessing={formStatusHeadingTextProcessing}
                statusTextProcessing={formStatusBriefTextProcessing}
                expTextSuccess={formStatusHeadingTextSuccess}
                statusTextSuccess={formStatusBriefTextSuccess}
                iconColor={formStatusIconColorClass}
                inputStyles="contact-form-input xxs:bg-green-light"
                contactLabelsClass={"text-white"}
                {...formAdditionalProps}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

Testimonials.defaultProps = {
  type: "program",
  heading: "Want to live a wilder life? Talk to us!",
  subHeading:
    "During office hours, we'll get back to you within a few minutes.",
  ctaLabel: "Get more information",
  bgType: "split",
  sectionBgClass: "bg-gray-tertiary ",
  layout: "default",
  illustrationSrc: {
    dark: (
      <AnemoneIllustrationDesktopDark className="!absolute opacity-[15%] top-[8%] -left-[22%] !hidden sm:!hidden sm:" />
    ),
    light: (
      <AnemoneIllustrationDesktopLight className="!absolute opacity-[15%] top-[8%] -left-[22%] !hidden sm:!block sm:" />
    )
  },
  formTooltipIconStyles: "fill-white",
  calendlyLayout: "calendlyLayout"
};

const bgPerDeviceShape = {
  desktop: PropTypes.string,
  mobile: PropTypes.string
};

Testimonials.propTypes = {
  testimonials: PropTypes.array,
  type: PropTypes.string,
  form_type: PropTypes.string,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  ctaLabel: PropTypes.string,
  bgSrc: PropTypes.shape({
    light: PropTypes.shape(bgPerDeviceShape),
    dark: PropTypes.shape(bgPerDeviceShape)
  }),
  bgCol: PropTypes.string,
  bgType: PropTypes.string,
  illustrationSrc: PropTypes.shape({
    light: PropTypes.node,
    dark: PropTypes.node
  })
};

export default Testimonials;
